import { useFeatureFlag } from ".";

const isDev = process.env.NODE_ENV === "development";

const FeatureFlagController = ({
  children,
  flag,
}: {
  children: React.ReactNode;
  flag: string;
}) => {
  const isFeatureEnabled = useFeatureFlag(flag);
  if (!isFeatureEnabled && isDev) {
    return children;
  }

  return isFeatureEnabled ? <>{children}</> : <></>;
};

export default FeatureFlagController;
